export class DialogModel {
    constructor(public title: string, public message: string, public cancelButton?: string, public confirmButton?: string,
                public hideCancel?: boolean) {
    }
}
